var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidationPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45 14.7183C3.75 14.7183 0.731247 11.7058 0.731247 7.99951C0.731247 4.29326 3.75 1.28076 7.45 1.28076C11.15 1.28076 14.1687 4.29326 14.1687 7.99951C14.1687 11.7058 11.1562 14.7183 7.45 14.7183ZM7.45 2.21826C4.2625 2.21826 1.66875 4.81201 1.66875 7.99951C1.66875 11.187 4.2625 13.7808 7.45 13.7808C10.6375 13.7808 13.2312 11.187 13.2312 7.99951C13.2312 4.81201 10.6375 2.21826 7.45 2.21826Z",
    fill: "#7F738E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95 8.46826H4.95C4.69375 8.46826 4.48125 8.25576 4.48125 7.99951C4.48125 7.74326 4.69375 7.53076 4.95 7.53076H9.95C10.2062 7.53076 10.4187 7.74326 10.4187 7.99951C10.4187 8.25576 10.2125 8.46826 9.95 8.46826Z",
    fill: "#7F738E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationPoint);
export default __webpack_public_path__ + "static/media/validation-point.896e8714b6ee2d71a042ea704c2ce64d.svg";
export { ForwardRef as ReactComponent };